module.exports = __webpack_public_path__ + "static/tabor-logo-84ecc573ba69574f5cfb4061d5ab5573.png";